/**
 * Mayfair Lane — branding option surcharges (v3)
 * Hulk shows +$ prices on branding options as line properties, then can
 * also try to re-add the charge via draft-order checkout. This is the
 * single charging mechanism: real surcharge variants in the normal cart,
 * native Shopify checkout, Hulk price/checkout layer bypassed.
 *
 * Watches:
 *   - Custom Branding for Box  (printed boxes)
 *   - Custom Brand Baskets     (logo ribbon / basket branding)
 */
(function () {
  if (window.__mayfairBrandingSurcharge) return;
  window.__mayfairBrandingSurcharge = true;

  var PROP_KEYS = [
    'Custom Branding for Box',
    'Custom Brand Baskets',
  ];
  var MARKER = '_mayfair_branding_surcharge';

  // Canonical labels → surcharge variant
  var BY_LABEL = {
    'My Logo Printed Box (Under 15 Boxes)': {
      id: 67618447753513,
      perUnit: true,
    },
    'My Logo Printed Box (15+ Boxes)': {
      id: 67618447687977,
      perUnit: true,
    },
    'My Logo on Ribbon (1 Roll 90m)': {
      id: 67618447819049,
      perUnit: false,
    },
  };

  // Older / alternate Hulk wording → canonical label
  var ALIASES = {
    'My Logo Ribbon (1 Roll 90m)': 'My Logo on Ribbon (1 Roll 90m)',
  };

  var VARIANT_IDS = {};
  Object.keys(BY_LABEL).forEach(function (label) {
    VARIANT_IDS[BY_LABEL[label].id] = label;
  });

  var syncPromise = null;

  function matchLabel(val) {
    if (!val) return null;
    var s = String(val);
    var keys = Object.keys(BY_LABEL);
    for (var i = 0; i < keys.length; i++) {
      if (s.indexOf(keys[i]) !== -1) return keys[i];
    }
    var aliasKeys = Object.keys(ALIASES);
    for (var j = 0; j < aliasKeys.length; j++) {
      if (s.indexOf(aliasKeys[j]) !== -1) return ALIASES[aliasKeys[j]];
    }
    return null;
  }

  function labelFromItemProps(props) {
    if (!props) return null;
    var i;
    for (i = 0; i < PROP_KEYS.length; i++) {
      var label = matchLabel(props[PROP_KEYS[i]]);
      if (label) return label;
    }
    // Fallback: any property value that contains a known branding label
    var keys = Object.keys(props);
    for (i = 0; i < keys.length; i++) {
      if (keys[i] === MARKER || keys[i].charAt(0) === '_') continue;
      var found = matchLabel(props[keys[i]]);
      if (found) return found;
    }
    return null;
  }

  function desiredFromCart(cart) {
    var wanted = {};
    (cart.items || []).forEach(function (item) {
      if (VARIANT_IDS[item.variant_id]) return;
      var props = item.properties || {};
      if (props[MARKER]) return;
      var label = labelFromItemProps(props);
      if (!label) return;
      var cfg = BY_LABEL[label];
      if (cfg.perUnit) {
        wanted[label] = (wanted[label] || 0) + item.quantity;
      } else {
        // Ribbon = one roll per order
        wanted[label] = Math.max(wanted[label] || 0, 1);
      }
    });
    return wanted;
  }

  function findSurchargeLines(cart) {
    var byVariant = {};
    (cart.items || []).forEach(function (item) {
      if (VARIANT_IDS[item.variant_id]) {
        byVariant[item.variant_id] = item;
      }
    });
    return byVariant;
  }

  function doSync() {
    if (syncPromise) return syncPromise;
    syncPromise = (async function () {
      var changed = false;
      try {
        var cart = await fetch('/cart.js').then(function (r) {
          return r.json();
        });
        var wanted = desiredFromCart(cart);
        var existing = findSurchargeLines(cart);
        var updates = {};
        var adds = [];

        Object.keys(BY_LABEL).forEach(function (label) {
          var cfg = BY_LABEL[label];
          var need = wanted[label] || 0;
          var line = existing[cfg.id];
          if (need > 0 && !line) {
            var props = {};
            props[MARKER] = '1';
            props['Branding surcharge'] = label;
            adds.push({ id: cfg.id, quantity: need, properties: props });
          } else if (line && line.quantity !== need) {
            updates[line.key] = need;
          }
        });

        Object.keys(existing).forEach(function (vid) {
          var line = existing[vid];
          var label = VARIANT_IDS[line.variant_id];
          var need = label ? wanted[label] || 0 : 0;
          if (need === 0) updates[line.key] = 0;
        });

        if (Object.keys(updates).length) {
          changed = true;
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates }),
          });
        }
        for (var i = 0; i < adds.length; i++) {
          changed = true;
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(adds[i]),
          });
        }

        if (
          changed &&
          window.location.pathname.indexOf('/cart') === 0 &&
          !window.__mayfairSurchargeReload
        ) {
          window.__mayfairSurchargeReload = true;
          window.location.reload();
        }
      } catch (e) {
        console.warn('[mayfair branding surcharge]', e);
      } finally {
        syncPromise = null;
      }
      return changed;
    })();
    return syncPromise;
  }

  function scheduleSync() {
    setTimeout(function () {
      doSync();
    }, 400);
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var input = args[0];
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return origFetch.apply(this, args).then(function (res) {
      if (
        /\/cart\/(add|change|update|clear)/.test(url) &&
        !window.__mayfairSyncingFetch
      ) {
        scheduleSync();
      }
      return res;
    });
  };
  var _doSyncInner = doSync;
  doSync = function () {
    window.__mayfairSyncingFetch = true;
    var p = _doSyncInner();
    if (p && p.finally) {
      p.finally(function () {
        setTimeout(function () {
          window.__mayfairSyncingFetch = false;
        }, 50);
      });
    }
    return p;
  };

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      var btn =
        t && t.closest
          ? t.closest(
              'button[name="checkout"], input[name="checkout"], [name="checkout"], #CartDrawer-Checkout'
            )
          : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var originalText = btn.innerHTML;
      btn.disabled = true;
      doSync()
        .then(function () {
          window.location.assign('/checkout');
        })
        .catch(function () {
          window.location.assign('/checkout');
        })
        .finally(function () {
          btn.disabled = false;
          btn.innerHTML = originalText;
        });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(doSync, 700);
    });
  } else {
    setTimeout(doSync, 700);
  }
})();
